import { createSubtemplate } from "@repo/design-system/lib/client-registry";
import type { SectionKey } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import { sharedOverrides, sharedSections } from "./default";

// Trainee has no experienceReports in the section bar (component returns null for this template)
const traineeSectionBarItems = [
  { href: "#job", label: "hungary_sectionBar_job", section: "job" },
  {
    href: "#applicationProcess",
    label: "hungary_sectionBar_applicationProcess",
    section: "applicationProcess",
  },
  { href: "#company", label: "hungary_sectionBar_company", section: "company" },
  {
    href: "#benefits",
    label: "hungary_sectionBar_benefits",
    section: "benefits",
  },
];

export const hungaryTrainee = createSubtemplate<SectionKey>({
  name: "hungary-trainee",
  trigger: (job) =>
    job.data.template === "HUN_Trainee" ||
    job.data.entryLevel === "Trainee" ||
    job.content.headerImage ===
      "images/header/subclients/hungary/07Intern.webp",
  showProd: true,
  config: {
    overrides: sharedOverrides,
    sections: sharedSections,
    sectionBarItems: traineeSectionBarItems,
  },
});
